/* CUSTOM CODE */
// Scrolling Sticky
$(document).ready(function() {
  const headerA = $('header');
  headerA.addClass('for-test');

  var searchChecker = setInterval(function(){
      if ($('body').hasClass('boost-pfs-enable-instant-search')) {
          $('.search-header-wrapper').removeClass('disabled');
          clearInterval(searchChecker);
      }
  }, 500);

  $('.search-icon').on('click', function(){
      $('.search-header-wrapper').addClass('open');
      $('.boost-pfs-search-suggestion-wrapper').removeClass('forcehide');
      $('.boost-pfs-search-input-v2').click();
      $('.boost-pfs-search-input-v2').focus();
  });

  $(window).click(function() {
      $('.search-header-wrapper').removeClass('open');
      $('.boost-pfs-search-suggestion-wrapper').addClass('forcehide');
      $('.boost-pfs-search-input-v2').val('');
  });

  $('.search-header-wrapper, .boost-pfs-search-suggestion-wrapper').click(function(event){
      event.stopPropagation();
  });

  $("form.boost-pfs-search-form").submit(function(e){
      // e.preventDefault();
  });

  $('#shopify-section-snw-header').remove();
});

$.fn.slideToggle = function (duration, callback, isDown) {
  if (typeof duration === "undefined") duration = 0;
  if (typeof isDown === "undefined") isDown = false;

  this.css('overflow', 'hidden');

  if (isDown) {
      this.css('display', 'block');
  }

  var elHeight = this.height();
  var elPaddingTop = parseFloat(this.css("padding-top"));
  var elPaddingBottom = parseFloat(this.css("padding-bottom"));
  var elMarginTop = parseFloat(this.css("margin-top"));
  var elMarginBottom = parseFloat(this.css("margin-bottom"));

  var stepHeight = elHeight / duration;
  var stepPaddingTop = elPaddingTop / duration;
  var stepPaddingBottom = elPaddingBottom / duration;
  var stepMarginTop = elMarginTop / duration;
  var stepMarginBottom = elMarginBottom / duration;

  var start;

  function step(timestamp) {
      if (start === undefined) start = timestamp;

      var elapsed = timestamp - start;

      if (isDown) {
          this.css('height', stepHeight * elapsed + "px");
          this.css('paddingTop', stepPaddingTop * elapsed + "px");
          this.css('paddingBottom', stepPaddingBottom * elapsed + "px");
          this.css('marginTop', stepMarginTop * elapsed + "px");
          this.css('marginBottom', stepMarginBottom * elapsed + "px");
      } else {
          this.css('height', elHeight - stepHeight * elapsed + "px");
          this.css('paddingTop', elPaddingTop - stepPaddingTop * elapsed + "px");
          this.css('paddingBottom', elPaddingBottom - stepPaddingBottom * elapsed + "px");
          this.css('marginTop', elMarginTop - stepMarginTop * elapsed + "px");
          this.css('marginBottom', elMarginBottom - stepMarginBottom * elapsed + "px");
      }

      if (elapsed >= duration) {
          this.css('height', '');
          this.css('paddingTop', '');
          this.css('paddingBottom', '');
          this.css('marginTop', '');
          this.css('marginBottom', '');
          this.css('overflow', '');

          if (!isDown) {
              this.css('display', 'none');
          }

          if (typeof callback === "function") {
              callback();
          }
      } else {
          window.requestAnimationFrame(step.bind(this));
      }
  }

  window.requestAnimationFrame(step.bind(this));
};

$.fn.slideUp = function (duration, callback) {
  this.slideToggle(duration, callback);
};

$.fn.slideDown = function (duration, callback) {
  this.slideToggle(duration, callback, true);
};

function updateImagesBasedOnDropdowns() {
  var dropdownImage1 = $('#dropdownImage1');
  var dropdownImage2 = $('#dropdownImage2');
  var dropdownLinks = $('.menu-item.expand-btn');

  dropdownImage1.hide();
  dropdownImage2.hide();

  dropdownLinks.each(function(index, link) {
      if ($(link).hasClass('open')) {
          if (index === 0) {
              dropdownImage1.show();
          } else if (index === 1) {
              dropdownImage2.show();
          }
      }
  });
}

const overlays = $('.the-overlay');
const body = $('body');
const menuBtn = $('.menu-btn');
const menuItems = $('.menu-items');

const liElems = $('.menu-items li');
liElems.each(function(index, elem) {
  const childrenElems = $(elem).find('.dropdown-menu');
  if (childrenElems.length > 0) {
      $(elem).children(':first-child').addClass('expand-btn');
      $(elem).addClass('dropdown');
  }
});

function toggle() {
  menuBtn.toggleClass('open');
  menuItems.toggleClass('open');
  body.toggleClass('the-overflow');
  overlays.toggleClass('overlay--active');

  const firstExpandButton = $('.menu-item.expand-btn').first();
  if (firstExpandButton.length) {
      if (menuBtn.hasClass('open')) {
          firstExpandButton.addClass('open');
          firstExpandButton.next().slideDown(200);
      } else {
          firstExpandButton.removeClass('open');
          firstExpandButton.next().slideUp(200);
      }
  }

  setTimeout(updateImagesBasedOnDropdowns, 10);
}

window.onkeydown = function(event) {
  const key = event.key;
  const active = menuItems.hasClass('open');
  if (key === 'Escape' && active) {
      toggle();
  }
};

$(document).on('click', function(eTarget) {
  const target = $(eTarget.target);
  const its_menu = target.is(menuItems) || menuItems.has(target).length;
  const its_hamburger = target.is(menuBtn);
  const menu_is_active = menuItems.hasClass('open');
  if (!its_menu && !its_hamburger && menu_is_active) {
      toggle();
  }
});


// Mobile menu expand
document.addEventListener("DOMContentLoaded", function() {
    // Mobile menu expand logic
    const expandBtn = document.querySelectorAll(".expand-btn");
    expandBtn.forEach((btn) => {
      btn.classList.remove("open");
      btn.addEventListener("click", (ebb) => {
          if (window.innerWidth <= 1024) {
              ebb.preventDefault(); // Prevent Default Anchor Click Behavior
              closeAllDropdownsExcept(btn); // Close all other dropdowns first
  
              // Wrap the native DOM element with jQuery
              const $nextElementSibling = $(btn.nextElementSibling);
  
              // Toggle 'open' class
              btn.classList.toggle("open");
  
              // Check current visibility state and toggle accordingly
              if ($nextElementSibling.is(":visible")) {
                  $nextElementSibling.slideUp(200);
              } else {
                  $nextElementSibling.slideDown(200);
              }
  
              // Update images based on the new state of dropdowns
              setTimeout(updateImagesBasedOnDropdowns, 10);
          }
      });
  });

    function closeAllDropdownsExcept(currentBtn) {
      expandBtn.forEach(function (btn) {
          if (btn !== currentBtn && btn.classList.contains("open")) {
              btn.classList.remove("open");
              $(btn.nextElementSibling).slideUp(200); // Wrap with jQuery and then slide up
          }
      });
  }

    // Initial check in case any dropdown is already open
    updateImagesBasedOnDropdowns();
    
    window.addEventListener("resize", () => {
      if (window.innerWidth > 1024) {
        // Off menu mobile on desktop
        if (menuBtn.classList.contains("open")) {
          toggle();
        }
        // Change arrow menu on Desktop
        for (var i = 0; i < expandBtn.length; i += 1) {
          expandBtn[i].classList.remove("open");
        }
        // Off SlideToggle Menu on Desktop
        const dropdownMenu = document.querySelectorAll(".menu-items .dropdown-menu");
        for (var i = 0; i < dropdownMenu.length; i += 1) {
          dropdownMenu[i].style.display = "";
        }
      }
    });
});


// Close the menu when a .menu-item-inn element is clicked
document.querySelectorAll('.menu-item-inn').forEach(menuItem => {
menuItem.addEventListener('click', () => {
    if (menuItems.classList.contains("open")) {
        toggle(); // Assuming 'toggle' is your function to open/close the menu
    }
});
});


menuBtn.on('click', function(e) {
  e.stopPropagation();
  toggle();
});

$('.menu-item-inn').on('click', function() {
  if (menuItems.hasClass('open')) {
      toggle();
  }
});

window.onload = function() {
  // Check if there is a fragment identifier in the URL
  const currentFragment = window.location.hash.substring(1);

  if (currentFragment) {
    // Find the target element using the fragment identifier
    const target = document.getElementById(currentFragment);

    if (target) {
      const targetRect = target.getBoundingClientRect();
      const offsetTop = targetRect.top + window.pageYOffset - 180;

      console.log(offsetTop);

      // Use vanilla JavaScript to animate scrolling
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }
  }
};

document.querySelectorAll('a[href*="#"]').forEach(function(elementTs) {
  elementTs.addEventListener('click', function(eoa) {
    const href = this.getAttribute('href');
    const targetId = href.split('#')[1]; // Get the fragment identifier

    // Use the fragment identifier as the target
    const target = document.getElementById(targetId);

    if (target) {
      const targetRect = target.getBoundingClientRect();
      const offsetTop = targetRect.top + window.pageYOffset - 180;
      console.log(offsetTop);
      // Use vanilla JavaScript to animate scrolling
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });

      // Prevent the default behavior only if there is a fragment identifier
      if (targetId) {
        eoa.preventDefault();
      }
    }
  });
});
